/**
 * Frontend Supabase client. Uses the publishable (anon) key so all queries
 * respect Row Level Security. NEVER reference the service-role key from
 * frontend code — the backend owns admin-level access via
 * `backend/src/config/supabase.ts`.
 *
 * Env values are validated at import time via `@/lib/env`, so a missing
 * VITE_SUPABASE_* variable throws a clear error at app boot rather than
 * a confusing failure later in the auth flow.
 *
 * Import as: `import { supabase } from "@/integrations/supabase/client";`
 */
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { env } from '@/lib/env';

export const supabase = createClient<Database>(env.SUPABASE_URL, env.SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});